import { Component, Input, OnChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-fading-message-popup',
  templateUrl: './fading-message-popup.component.html',
  styleUrls: ['./fading-message-popup.component.scss']
})
export class FadingMessagePopupComponent implements OnChanges {
  @Input() message: string = '';
  @Input() type: 'success' | 'error' = 'success';
  @Input() displayDuration: number = 3000;
  @Input() fadeDuration: number = 3000;
  @Input() trigger: number = 0; // Trigger to force popup refresh
  // Hidden again from a timer, so this must be signal-based under OnPush.
  readonly show = signal(false);

  ngOnChanges(): void {
    // Show popup when message is provided
    // The trigger input is optional - if not provided (remains 0), use original behavior
    // If trigger is provided, it ensures popup shows even with same message content
    if (this.message) {
      this.show.set(true);
      setTimeout(() => {
        this.show.set(false);
      }, this.displayDuration);
    }
  }
}
